import { Center, Spinner, Text } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import PortfolioCurrencyStatisticList from 'presentation/components/modules/portfolio/PortfolioCurrencyStatisticList';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';

const PortfolioCurrenciesContainer: FC = () => {
  const { t } = useTranslation();

  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  const wrapByCard = !data;
  let content;
  if (data) {
    if (data.currencyBalances.length > 0) {
      content = (
        <PortfolioCurrencyStatisticList
          currenciesData={data.currencyBalances}
        />
      );
    } else {
      content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <>
      <GridHeading>{t('currencies')}</GridHeading>
      {content}
    </>
  );
};

export default PortfolioCurrenciesContainer;
